// JsFromRoutes CacheKey 80a91e7a6132c85b20f215aec9bc8cff
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/testing_tools/tutorial_card'),
}
